define('ZipCodeSession', ['jQuery', 'ZipCodeSession.Model'], function ZipCodeSession(
  jQuery,
  ZipCodeSessionModel
) {
  'use strict';

  var model = new ZipCodeSessionModel();

  return {
    getZipCode: function getZipCode() {
      var deferred = jQuery.Deferred();
      model
        .fetch()
        .done(function done() {
          deferred.resolve(model.getZipCode());
        })
        .fail(function fail(error) {
          deferred.reject(error);
        });
      return deferred.promise();
    },

    setZipCode: function setZipCode(zipCode) {
      model.setZipCode(zipCode);
      return model.save();
    },

    clearZipCode: function clearZipCode() {
      var deferred = jQuery.Deferred();
      // setting id to be able to destroy
      model.set('internalid', String(new Date().getTime()));
      model
        .destroy()
        .done(function done() {
          model = new ZipCodeSessionModel();
          deferred.resolve();
        })
        .fail(function fail(error) {
          deferred.reject(error);
        });
      return deferred.promise();
    }
  };
});
